import { STORAGE_KEY, UPDATE_EVENT_NAME, RECENT_DOCS_LIMIT } from "../constants"
import type { RecentDocsByRepo } from "../types"
import { getRepoFromPath } from "./repo"

export function loadRecentDocs(): RecentDocsByRepo {
  if (typeof window === "undefined") return {}
  try {
    const stored = localStorage.getItem(STORAGE_KEY)
    return stored ? JSON.parse(stored) : {}
  } catch (error) {
    console.error("Failed to load recent docs:", error)
    return {}
  }
}

function handleStorageError(error: unknown): void {
  if (
    error instanceof DOMException &&
    (error.name === "QuotaExceededError" ||
      error.name === "NS_ERROR_DOM_QUOTA_REACHED" ||
      error.code === 22 ||
      error.code === 1014)
  ) {
    console.warn(
      "localStorage quota exceeded or unavailable (private browsing)"
    )
  } else {
    console.error("Failed to save recent doc:", error)
  }
}

export function saveToRecentHistory(path: string, title: string): void {
  if (typeof window === "undefined") return

  if (path.endsWith("/docs/") || path.endsWith("/docs")) {
    return
  }

  if (!path.includes("/docs/")) {
    return
  }

  const repo = getRepoFromPath(path)
  if (!repo) return

  try {
    const recentByRepo = loadRecentDocs()

    if (!recentByRepo[repo]) {
      recentByRepo[repo] = []
    }

    recentByRepo[repo] = recentByRepo[repo].filter((doc) => doc.path !== path)

    recentByRepo[repo].unshift({
      path,
      title,
      timestamp: Date.now(),
    })

    recentByRepo[repo] = recentByRepo[repo].slice(0, RECENT_DOCS_LIMIT)

    localStorage.setItem(STORAGE_KEY, JSON.stringify(recentByRepo))

    window.dispatchEvent(
      new CustomEvent(UPDATE_EVENT_NAME, {
        detail: { recentByRepo },
      })
    )
  } catch (error) {
    handleStorageError(error)
  }
}
